import { createData } from './fetch-data';
import { partsSorted } from '../reducers/parts';
import { REORDER_PARTS } from '../constants/endpoints';
import { UPDATE_PART } from '../constants/constants';

export { part_selected, partMoved } from '../reducers/parts';

// Reads the order from the store rather than component props: react-dnd fires the
// final hover and the drag end in the same tick, before the page has re-rendered.
export function savePartsOrder(){
  return (dispatch, getState) => {
    dispatch(partsSorted());

    const { parts } = getState().parts;

    return dispatch(createData(REORDER_PARTS, UPDATE_PART, {
      parts: parts.map(part => ({ id: part._id.$oid, sort: part.sort }))
    }));
  };
}
